// Bootstrap's info, warning and light fills are light colors: white text on
// them is 1.9:1, 1.6:1 and 1.1:1, under the 4.5:1 WCAG 1.4.3 needs. Every
// Badge whose fill is chosen at runtime passes its variant through here so a
// status map can list any variant without regressing contrast.
const DARK_TEXT_FILLS = new Set(['info', 'warning', 'light']);

export const badgeTextFor = (bg) =>
    DARK_TEXT_FILLS.has(bg) ? 'dark' : undefined;

export default badgeTextFor;
